import {
    AfterViewInit,
    Component,
    effect,
    ElementRef,
    input,
    viewChild,
    ViewEncapsulation,
} from '@angular/core';

/**
 * Native port of the AngularJS `ftIframeContent` directive
 * (account-v1/.../components/common/iframe-content/iframeContent.js). Writes the
 * bound HTML string into a child `<iframe>` imperatively via
 * `contentWindow.document.write` (Angular template binding can't render into an
 * iframe document). Reproduces the v1 markup verbatim — an optional
 * `.iframe-overlay` wrapper div + the `<iframe>` — so the global LESS
 * (`.iframe-container` / `.iframe-overlay`) lays it out identically. Used by the
 * native invitations sheet's share-image preview.
 */
@Component({
    selector: 'ft-iframe-content-ng',
    imports: [],
    encapsulation: ViewEncapsulation.None,
    templateUrl: './ft-iframe-content.component.html'
})
export class FtIframeContentComponent implements AfterViewInit {
    readonly content = input<string | null>(null);
    readonly hasWrapper = input(false);

    private readonly frame = viewChild<ElementRef<HTMLIFrameElement>>('frame');

    constructor() {
        effect(() => this.write());
    }

    ngAfterViewInit(): void {
        this.write();
    }

    private write(): void {
        const content = this.content();
        if (!content) {
            return;
        }
        // Defer so the conditionally rendered iframe is in the DOM before writing.
        setTimeout(() => {
            const el = this.frame()?.nativeElement;
            if (!el) {
                return;
            }
            try {
                el.contentWindow!.document.open();
                el.contentWindow!.document.write(content);
                el.contentWindow!.document.close();
            } catch {
                // mirror v1: swallow cross-origin/timing errors silently
            }
        });
    }
}
